<template>
	<div class="inline-block popover-target-wrapper">
		<span v-on:mouseover="hover" v-on:mouseleave="hoverOut"><slot name="popover-target"></slot></span>
		<div class="popover-wrapper" :class="{'tooltip':isToolTip, right : position === 'right'}">
			<transition name="fade">
				<div class="popover" v-if="showPopup">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<h3 v-if="title">{{title}}</h3>
					<p>{{message}}</p>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'Popover',
	props: ['title', 'message', 'position', 'isToolTip'],
	    data: function () {
	        return {
	            showPopup: false,
	            isInInfo: false
	        };
	    },
	methods: {

	        hover(e) {
			const width = e.currentTarget.children[0].clientWidth;
	            let vm = this;
	            Vue.nextTick(()=>{
				vm.showPopover(width);
			});
	        },

	        hoverOut() {
	            let vm = this;
			Vue.nextTick(()=>{
				   vm.closePopover();
			   });
	        },

	        showPopover(width) {
	            this.showPopup = true;

	        },

	        closePopover () {
	            this.showPopup = false;
	        }
	    }
};
</script>

<style scoped>
	.half .popover-wrapper {
		max-width: 50%;
	}
	@media only screen and (max-width: 800px) {
		.half .popover-wrapper {
			max-width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// ./src/components/Popover.vue